import { AppNotification } from "@planzone/dto";

function updateNotification(
  nextNotification: AppNotification,
  notifications: AppNotification[],
) {
  const index = notifications.findIndex(
    ({ key }) => key === nextNotification.key,
  );

  return index !== -1
    ? [
        ...notifications.slice(0, index),
        nextNotification,
        ...notifications.slice(index + 1),
      ]
    : [...notifications, nextNotification];
}

export { updateNotification };
